document.addEventListener('DOMContentLoaded', function () {
    const lazyImages = document.querySelectorAll('img[loading="lazy"]');

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;

        //   if (img.parentElement) {
        //   img.parentElement.style.backgroundColor = '#000';
        // }

          if (img.complete) {
            img.classList.add('loaded');
          } else {
            img.addEventListener('load', () => {
              img.classList.add('loaded');
            }, { once: true });
          }

          observer.unobserve(img);
        }
      });
    }, {
      rootMargin: '0px 0px 5px 0px',
      threshold: 0.3
    });

    lazyImages.forEach(img => {
      observer.observe(img);
    });

    
    // Animate whole slider section
    const sections = document.querySelectorAll('.custom_animation');

    const sectionObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('loaded');
          observer.unobserve(entry.target);
        }
      });
    }, {
      rootMargin: '0px 0px 0px 0px',
      threshold: 0.4
    });

    sections.forEach(section => {
      sectionObserver.observe(section);
    });
    
  });